"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Staroutline = function Staroutline(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "StaroutlineTitle StaroutlineDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "StaroutlineTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "StaroutlineDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M20.494 9.867a.54.54 0 0 0-.44-.344L14.8 8.926 12.33 4.41a.55.55 0 0 0-.48-.281h-.016a.538.538 0 0 0-.48.304L9.139 9.057l-5.21.866a.532.532 0 0 0-.452.517c0 .152.067.29.174.385l3.882 3.461-.758 5.039a.535.535 0 0 0 .54.594.558.558 0 0 0 .259-.063l4.62-2.486 4.745 2.253c.07.034.153.054.241.054a.535.535 0 0 0 .545-.525.531.531 0 0 0-.013-.115l-1.03-4.982 3.689-3.648a.512.512 0 0 0 .123-.544v.004zm-4.792 3.654a.513.513 0 0 0-.144.471l.873 4.22-4.012-1.905a.555.555 0 0 0-.507.015l-3.899 2.102.64-4.267a.513.513 0 0 0-.172-.45l-3.284-2.929 4.407-.732a.544.544 0 0 0 .401-.293l1.876-3.914 2.084 3.815a.55.55 0 0 0 .414.277l4.434.508-3.111 3.082z"
  }));
};

Staroutline.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Staroutline.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Staroutline;
exports["default"] = _default;